import React from 'react'
import {
    Handle,
    Position
} from '@xyflow/react';

const initStyle = {
    width: 12,
    height: 12,
    background: '#7e8186',
}

function SourceHandle({ id, styles }) {
    return (
        <Handle
            id={id}
            type="source"
            position={Position.Right}
            style={{...initStyle, ...styles}}
        />
    )
}

export default SourceHandle
